export default {
  methods: {
    updateBreadcrumb: function(params) {
      if ("links" in params) {
        this.$store.commit("breadcrumb/updateDynamicLinks", {
          dynamic_links: params.links
        });
      }

      if ("currentPage" in params) {
        this.$store.commit("breadcrumb/setCurrentPage", {
          name: params.currentPage
        });
      }

      this.$store.commit("breadcrumb/display");
    }
  }
};
